import {useRouteMatch, Switch, Route} from 'react-router-dom';
import {Contact} from './contact';
import React, {FC} from 'react';

export const ContactRoute: FC = React.memo(() => {
  let match = useRouteMatch();

  return (
    <Switch>
      <Route path={match.path}>
        <Contact />
      </Route>
    </Switch>
  );
});
